module.exports = __webpack_public_path__ + "static/Jordan-0fbf783cc243f476a86d571259a425f6.png";